import React, { useEffect, useState } from 'react';
import './AppStoreRedirect.css';

const AppStoreRedirect = () => {
  const appStoreUrl = 'https://apps.apple.com/ma/app/croqly-crochet-knitting/id6753090359';
  const [showTikTokInstructions, setShowTikTokInstructions] = useState(false);

  // Detect if user is in TikTok's in-app browser or coming from TikTok safety page
  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isTikTokBrowser = userAgent.includes('tiktok') || 
                           userAgent.includes('musical_ly');
    const fromTikTokSafety = document.referrer.includes('tiktoklinksafety') ||
                            window.location.href.includes('tiktoklinksafety');
    const fromTikTok = document.referrer.includes('tiktok.com');
    
    // If coming from TikTok safety page (clicked "Open"), redirect immediately
    if (fromTikTokSafety) {
      window.location.replace(appStoreUrl);
      return;
    }
    
    // If in TikTok browser, show instructions
    if (isTikTokBrowser || fromTikTok) {
      setShowTikTokInstructions(true);
    } else {
      // For all other browsers, redirect immediately to App Store
      window.location.replace(appStoreUrl);
    }
  }, [appStoreUrl]);

  return (
    <div className="app-store-redirect">
      <div className="floating-elements">
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
      </div>

      <div className="redirect-content">
        {showTikTokInstructions && (
          <div className="tiktok-instruction-popup">
            <div className="instruction-content">
              <p className="instruction-text">
                On <span className="tiktok-logo">TikTok</span> you need to tap on the{' '}
                <span className="menu-icon">⋯</span> and then tap on{' '}
                <span className="highlight-text">"Open in browser"</span> to download the app.
              </p>
            </div>
          </div>
        )}

        <div className="app-icon-container">
          <img 
            src="croqly-logo.jpeg" 
            alt="Croqly App Icon" 
            className="app-icon"
          />
        </div>
        
        <h1 className="redirect-title">Croqly</h1>
        <p className="redirect-subtitle">Crochet Made Simple</p>
        
        <p className="redirect-text">
          Search "Croqly" on the App Store
        </p>

        <a
          href={appStoreUrl}
          className="download-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          Download App
        </a>

        {!showTikTokInstructions && (
          <p className="redirecting-text">
            Redirecting to App Store...
          </p>
        )}
      </div>
    </div>
  );
};

export default AppStoreRedirect;

